import api from './axios';

export const getMonthlyEvents = async (year, month) => {
  const response = await api.get(`/calendar/events/${year}/${month}`);
  return response.data;
};

export const getUpcomingEvents = async (days = 30, type = '') => {
  const response = await api.get('/calendar/events/upcoming', { params: { days, type } });
  return response.data;
};
